<template>
  <div class="card shadow mb-5">
    <div class="card-body">
      <h5 class="card-title text-secondary fw-bold text-uppercase">
        {{ title }}
      </h5>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
